




import lottie from "lottie-web";

export default {
  name: "BaseAnimation",
  data: function () {
    return {
      lottie: null,
    };
  },
  props: {
    json: {
      type: Object,
      default: null,
    },
    autoplay: { type: Boolean, default: false },
    paused: {
      type: Boolean,
      required: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    startFrame: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    autoplay: function () {
      if (!this.autoplay) {
        this.lottie.goToAndStop(this.startFrame);
      } else {
        this.lottie.play();
      }
    },
    paused: function () {
      if (this.paused) {
        this.lottie.pause();
      } else {
        this.lottie.play();
      }
    },
    json: function () {
      this.updateAnimation();

      if (!this.autoplay) {
        this.lottie.goToAndStop(this.startFrame);
      }
    },
  },
  mounted() {
    this.lottie = lottie.loadAnimation({
      container: this.$refs.element,
      renderer: "svg",
      loop: this.loop,
      autoplay: this.autoplay,
      animationData: this.json,
    });
    this.lottie.onComplete = () => {
      this.$emit("end");
    };
    this.lottie.onEnterFrame = () => {
      this.$emit("timeUpdate");
    };
    if (!this.autoplay) {
      this.lottie.goToAndStop(this.startFrame);
    }
  },
  methods: {
    getCurrentFrame() {
      return this.lottie.currentFrame;
    },
    goToAndPlay(time) {
      this.lottie.goToAndPlay(time, false);
    },
    goToAndStop(time) {
      this.lottie.goToAndStop(time, false);
    },
    updateAnimation() {
      this.lottie.destroy();
      this.lottie = lottie.loadAnimation({
        container: this.$refs.element,
        renderer: "svg",
        loop: this.loop,
        autoplay: this.autoplay,
        animationData: this.json,
      });
      if (this.paused) {
        this.lottie.pause();
      } else {
        this.lottie.play();
      }

      this.lottie.onComplete = () => {
        this.$emit("end");
      };
      this.lottie.onEnterFrame = () => {
        this.$emit("timeUpdate");
      };
    },
  },
};
